// @flow
//eslint-disable-next-line

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useTranslation } from '../../../../../../hooks'
import { ANALYTICS_HELPER, CONSTANTS } from '../../../../../../utils'
import { alertActions, cartActions } from '../../../../../../store/actions'

const MobileMenuWrapper = () => {
	const translate = useTranslation()
	const dispatch = useDispatch()

	const { showCartMenu } = useSelector((state) => state.action)
	const { count } = useSelector((state) => state.cart.cart_items)

	const showCounter = count >= 0

	useEffect(() => {
		if (count === 0 && showCartMenu) {
			dispatch(cartActions.TOGGLE_CART_ICON())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [count])

	const openCartMenu = () => {
		if (count > 0) {
			ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
				action: ANALYTICS_HELPER.EVENT.NAVIGATION.CART_MENU.ACTION,
				label: ANALYTICS_HELPER.EVENT.NAVIGATION.CART_MENU.LABEL,
				properties: {},
			})
			dispatch(cartActions.TOGGLE_CART_ICON())
		} else {
			dispatch(
				alertActions.warning(translate('GENERAL.EMPTY_CART'), CONSTANTS.ERROR_TYPE.TOAST, true)
			)
		}
	}
	return (
		<div className={`cartIcon ${count === 0 ? 'd-none' : ''}`} onClick={openCartMenu}>
			<span className="nav-link">
				<i className="icons-icon-cart"></i>
				{showCounter ? (
					<div className="cartCounter">
						<span>{count}</span>
					</div>
				) : (
					''
				)}
			</span>
		</div>
	)
}

export default MobileMenuWrapper
